/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Fast_ForwardInputs */



/**
* | output |
* | --- |
* | "Toggle Fast Forward" |
*
* @param {Shortcut_Keys_Name_Toggle_Fast_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_fast_forward = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Fast_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer avance rapide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnellvorlauf umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva avanzamento rapido")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить перемотку вперед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar avance rápido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换快进")
	if (locale === "ja") return /** @type {LocalizedString} */ ("早送りを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ास्ट फ़ॉरवर्ड टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar Avanço Rápido")
	return /** @type {LocalizedString} */ ("Toggle Fast Forward")
});